import { render } from "./SearchMentor.vue?vue&type=template&id=9f9c6162&scoped=true"
import script from "./SearchMentor.vue?vue&type=script&lang=js"
export * from "./SearchMentor.vue?vue&type=script&lang=js"

import "./SearchMentor.vue?vue&type=style&index=0&id=9f9c6162&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9c6162"]])

export default __exports__